export function Logo() {
  return (
    <div className="tw-w-[60px] tw-h-[60px] tw-p-2.5 tw-bg-[#3B4B59] tw-rounded-[48px] tw-flex-col tw-justify-center tw-items-center tw-gap-2.5 tw-flex">
      <div className="tw-text-white tw-text-2xl tw-font-extrabold tw-font-figtree tw-leading-normal">
        W
      </div>
    </div>
  );
}
